import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'
const prefix = localDev ? '' : requestPrefix.projectUrl

export function page(data) {
  return Axios({
    url: prefix + '/projectVisitCarLog/page',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/manage/car-visitor.js